import type { UserModel } from '@/schemas/User.schema';
import type { InjectionKey, Ref } from 'vue';

type AppUserProvide = {
    currentUser: Ref<UserModel>;
};

export const AppUserSymbol: InjectionKey<AppUserProvide> = Symbol.for('precision:app-user');
